import { render, staticRenderFns } from "./FooterContactSocial.vue?vue&type=template&id=04e589f2&lang=pug&"
import script from "./FooterContactSocial.vue?vue&type=script&lang=js&"
export * from "./FooterContactSocial.vue?vue&type=script&lang=js&"
import style0 from "./FooterContactSocial.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04e589f2')) {
      api.createRecord('04e589f2', component.options)
    } else {
      api.reload('04e589f2', component.options)
    }
    module.hot.accept("./FooterContactSocial.vue?vue&type=template&id=04e589f2&lang=pug&", function () {
      api.rerender('04e589f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/footer/FooterContactSocial.vue"
export default component.exports